// ******************** PROVIDERS DATA TABLE ********************
export const FETCH_PROVIDERS_LOADING = 'FETCH_PROVIDERS_LOADING';
export const FETCH_PROVIDERS_SUCCESS = 'FETCH_PROVIDERS_SUCCESS';
export const FETCH_PROVIDERS_ERROR = 'FETCH_PROVIDERS_ERROR';

// ******************** PROVIDERS NAMES BY ID ********************
export const FETCH_PROVIDERS_NAMES_BY_ID = 'FETCH_PROVIDERS_NAMES_BY_ID';
export const CLEAR_PROVIDERS_NAMES_BY_ID = 'CLEAR_PROVIDERS_NAMES_BY_ID';
